import React, {useEffect, useRef} from 'react';
import './VehicleNotMatch.css';

const VehicleNotMatch = ({ onAccept, onDecline, message }) => {
    
    const modalRef = useRef(null);

    useEffect(() => {
        if (modalRef.current) {
            modalRef.current.focus();
        }
    }, []);

    const TickIcon = () => (

        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
            <path d="M20.285 6.709l-11.285 11.291-5.285-5.291 1.415-1.414 3.87 3.876 9.87-9.876z"/>
        </svg>
    );
    
    return (
      <div className="modal-container">
        <div className="modal-box" tabIndex={-1} ref={modalRef}>
          <p className="message">
            {message['message-1'] || ''}
          </p>
          <div className="button-group">
            <button type="button" className="btn decline" onClick={onDecline}>
              <span className='close'>&times;</span> Decline
            </button>
            <button type="button" className="btn accept" onClick={onAccept}>
              <span>{TickIcon()}</span> Accept
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  export default VehicleNotMatch;
  
